<template>
  <Frame v-if="networkSiteLabels && networkSiteLabels.length" class="flex grow">
    <strong class="text-xl text-[#0891f5] font-bold leading-none">
      Platinum Offer
    </strong>
    <p>
      Keep your
      <strong>{{ userStore.siteName }}</strong>
      membership active
    </p>
    <p class="mb-2">
      to get
      <strong>Full Access</strong>
      to
      <strong>
        {{ networkSiteLabels.filter((s) => !s.base).length }} Exclusive Sites
      </strong>
    </p>

    <strong class="text-[#0891f5] font-bold mb-2">Included Sites</strong>

    <div class="grid grid-cols-2 gap-2">
      <div
        v-for="site in networkSiteLabels.filter((s) => !s.base)"
        :key="site.name"
        class="flex flex-row items-center gap-2 leading-none"
      >
        <div>
          <a
            :href="site.host"
            target="_blank"
            class="text-[#0891f5] font-bold whitespace-nowrap"
          >
            <font-awesome-icon
              icon="fa-solid fa-circle-check"
              class="text-green-600"
            />
            <span
              class="ml-1 font-bold whitespace-nowrap"
              v-html="siteNameToColoredText(site.cachedSlug)"
            />
          </a>
        </div>
      </div>
    </div>
  </Frame>
</template>

<script setup>
  defineOptions({
    name: "LifetimeOfferSiteList",
  })

  const currentSite = inject("currentSite")
  const userStore = useUserStore()
  const { networkSiteLabels } = useMembersArea()
  const { siteNameToColoredText } = useSiteSettings(currentSite.value)
</script>
